import { render, staticRenderFns } from "./CollectSchoolZyz.vue?vue&type=template&id=60d34d50&scoped=true&"
import script from "./CollectSchoolZyz.vue?vue&type=script&lang=js&"
export * from "./CollectSchoolZyz.vue?vue&type=script&lang=js&"
import style0 from "./CollectSchoolZyz.vue?vue&type=style&index=0&id=60d34d50&prod&lang=stylus&scoped=true&"
import style1 from "./CollectSchoolZyz.vue?vue&type=style&index=1&id=60d34d50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d34d50",
  null
  
)

export default component.exports